export var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/utils/throwServerError.js
// module id = ./node_modules/@apollo/client/link/utils/throwServerError.js
// module chunks = 53 54